<template>
  <div class="alert-container">
    <!-- Header-->
    <div class="row">
      <div class="col-md-6 pR0"  @click="IsAlerts = true ; IsTasks = false">
        <div class="alert-header" :class="{'activeTab': IsAlerts}">
          <div style="text-align:center;border-right:4px;"><h4 class="box-section-heading">ALERTS</h4><span class="span-color">{{alertCount}}</span></div>
        </div>
      </div>
      <div class="col-md-6 pL0"  @click="IsTasks = true ; IsAlerts = false">
        <div class="alert-header" :class="{'activeTab': IsTasks}">
          <div style="text-align:center"><h4 class="box-section-heading">TASKS</h4><span class="span-color">{{tasksTotalCount}}</span></div>
        </div>
      </div>
    </div>
    <!-- Alerts Section -->
    <div class="alert-body" v-if="IsAlerts">
      <div class="MT-Content-table" v-if="isLoading && alerts.length == 0">
        <div class="MT-Content"> <ob-spinner></ob-spinner></div>
      </div>
      <div class="row" style="margin:0px;" v-else-if="alerts && alerts.length > 0">
        <div class="col-md-12 Task-header" style="text-align: center;">
          <a  @click="viewAll" class="addTask">
            <h4>
              View All
              <i class="fa fa-long-arrow-right"></i>
            </h4>
          </a>
        </div>
        <div v-for="(data, index) in alerts" :key="index">
          <div @click="onAlertClick(data)" class="col-md-12 alert-content" :class="{'alert-content-unread':!data.IsRead}">
            <div class="col-md-2" style="padding-left:10px;padding-right:0">
              <img v-if="data.AlertType == 'Warning' " :src='`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/info-icon-orange.svg`' style="width:20px;border-radius:50%;margin-left:10px;">
              <img v-else :src='`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/info_red_icon.svg`' style="width:20px;border-radius:50%;margin-left:10px;">
            </div>
            <div class="col-md-10" style="padding-left:0px;">
              <p style="font-weight:600;word-break: break-word;margin-bottom:10px;">{{getDescription(data.Description)}}</p>
              <div class="alert-time">
                <p><img style="width: 16px;margin-right:10px;" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_timestamp.svg`"/>{{data.ModifiedDateTime | humantime}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class=col-md-12>
          <a href="javascript:;" v-if="isLoadMoreAlerts && !isLoading" @click="loadMore" class="load-more-link">Load More</a>
          <ob-spinner v-if="isLoading"></ob-spinner>
        </div>
      </div>
      <div class="MT-Content-table" v-else>
        <div class="MT-Content">
          <div style="margin-bottom: 20px;"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/dash-board/ic_empty_alerts.svg`"></div>
          <div style="font-size: 14px;">All caught up!!</div>
        </div>
      </div>
    </div>
    <!-- End Alert Section -->

    <!-- Tasks Section -->
    <div class="alert-body" v-else>
      <div class="MT-Content-table" v-if="isLoading && TaskList.length == 0">
        <div class="MT-Content"> <ob-spinner></ob-spinner></div>
      </div>
      <div class="row" style="margin:0px;" v-else-if="TaskList && TaskList.length > 0">
        <div class="col-md-12 Task-header" style="text-align: center;">
          <a @click="openAddTaskPopup = true ; isEdit = false" class="addTask">
            <h4>
              Add Task
              <i class="fa fa-long-arrow-right"></i>
            </h4>
          </a>
        </div>
        <div v-for="(item, index) in TaskList" :key="index">
          <div class="col-md-12 alert-content" style="padding: 4px;" @click="onClickCard(item)">
            <div class="col-md-12" style="margin-top:6px;margin-bottom:10px;">
              <div class="col-md-10 pL0 pR0">
                <span class="task-title"> {{item.Title}}</span>
              </div>
              <div class="col-md-2 pL0 pR0">
                <ul class="pull-right clearfix list-unstyled list-inline task-actions" style="margin:0px;">
                  <li id="editButton" :class="{'deleteTask':deleteDisable(item)}" @click.stop="editTask(item)">
                    <span><i class="fa fa-pencil" aria-hidden="true" ></i></span>
                  </li>
                  <li id="deleteButton" :class="{'deleteTask':deleteDisable(item)}" @click.stop="confirmDeletetask(item)">
                    <span><i class="fa fa-trash" aria-hidden="true" ></i></span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-md-12" style="margin-bottom:10px;">
              <span class="task_date"><img style="width:16px;margin-right: 10px;" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_timestamp.svg`"></span>
              <span style="font-size:11px"> {{item.CreatedDate}}</span>
              <span v-if="item.Status != 'None'" v-bind:class="item.Status == 'Pending' ? 'status':'status1'">{{item.Status}}</span>
            </div>
          </div>
        </div>
        <div class=col-md-12>
          <a href="javascript:;" v-if="isLoadMoreTasks && !isLoading" @click="loadMore" class="load-more-link">Load More</a>
          <ob-spinner v-if="isLoading"></ob-spinner>
        </div>
      </div>
      <div class="MT-Content-table" v-else>
        <div class="MT-Content">
          <div style="margin-bottom:20px;"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_notasks.svg`"/></div>
            <div style="font-size: 14px;margin-bottom:15px;">
              You haven’t added any task yet. Try adding a new one.
            </div>
            <a @click="openAddTaskPopup = true ; isEdit = false">
              <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_add.svg`"/>
              <span style="color:#464444;font-weight: 600;">
                Add Task
              </span>
            </a>
          </div>
      </div>
      <add-task :openModal.sync="openAddTaskPopup" :IsEdit ="isEdit" :PreviousData ="previousData" @taskAdded="taskAdded"></add-task>
    </div>
    <!-- End Tasks Section -->
  </div>
</template>
<script>
import AddTask from '../Timesheets/AddTask.vue'
export default {
  data(){
    return{
      alerts: [],
      previousData:'',
      isEdit:false,
      isLoading: true,
      IsTasks : false,
      IsAlerts: true,
      alertCount: 0,
      isLoadMoreTasks: true,
      isLoadMoreAlerts:true,
      pageNo: 0,
      pageSize: 20,
      tasksTotalCount: 0,
      TaskList:[],
      openAddTaskPopup: false,
      SearchIntent: 0,
      AlertList : [],
      passwordCode : ''
    }
  },
  created(){
    this.getAlerts()
    this.getTasks()  
    bus.listen("refreshProfileAlertsListener", () => {
       if(this.$route.name == "ess-dashboard")
       {
                this.alerts = [];
                this.AlertList = [];
                this.getAlerts();
       }
    });
    this.interval = setInterval(() => {
         this.alerts = [];
         this.alerts = this.AlertList;
    }, 1000);
  },
  components:{
    "add-task" : AddTask
  },
  computed: {
    EmployeeId() {
      return  this.loggedInUserObj.empId ? this.loggedInUserObj.empId : '';
    }
  },
  methods:{  
    // getPassCode(empId, recepientEmail)
    // {  
    //    this.$loading({'loadingText': 'Loading...'})
    //   ajax.get(`GeneratePasswordResetToken?userId=${loggedInUserObj.consultantId}`, {} , (res) => {
    //     if(res.data != null || res.data != ''){
    //       console.log(res)
    //        this.passwordCode = res.data;
    //        var url = `/SetPassword.html?empId=${empId}&pwdCode=${this.passwordCode}&consultantId=${loggedInUserObj.consultantId}&email=${recepientEmail}`
    //        window.open(url, "_blank")
    //     }
    //     this.$loading({}).close()
    //   })
    // },
    getDescription(desc)
    {
       return desc.replace(loggedInUserObj.name + "'s", "Your");
    },
    getAlerts(){
      this.isLoading = true
      var Obj = {
        "SortBy" : '',
        "Filter" : {
          "FromDate" : '',
          "ToDate" : '',
          "AlertSettings" : ''
        },
        "SearchIntent" : this.SearchIntent
      }
      ajax.put(`/Compliance/GetAlerts?empId=${this.loggedInUserObj.empId}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`, Obj ,(res) => {
        this.alertCount = res.data.Count
        var alertsLength = res.data.AlertList.length;
        if(alertsLength > 0) {
            this.alerts.push.apply(this.alerts, res.data.AlertList);
            this.AlertList = this.alerts;
            if(alertsLength < this.pageSize)
              this.isLoadMoreAlerts = false;
        }
        else {
          this.isLoadMoreAlerts = false;
        }
        this.isLoading = false
      })
    },
    readUnreadMethod(k) {
      let _this = this;
      ajax.put(`/Compliance/AlertMarkedasReadOrUnread?alertId=${k}`, {}, ( res ) => {
        let index = this.alerts.findIndex(a => a.Id == k)
        if(index != -1) {
          Vue.set(this.alerts[index], "IsRead", !this.alerts[index].IsRead )
        }
      });
    },
    onAlertClick(data) {
      let url="" ;
      var hireType = data.HireType != null ? data.HireType : "W2";
      if(!data.IsRead){
        this.readUnreadMethod(data.Id);
      }

      if(data.AlertGroup == "FormI983") {
        url = `/employee/form-i983`
      }
      else if(data.AlertGroup == "H1B") {
        if(hireType == "C2C" || hireType == "1099")
        {
          url = `/employee`
        }
        else
        {
          url = `/employee/h1b`
        }
      }
      else if(data.AlertGroup == "FormI9") {
        url = `/employee/i9`
      }
      else if(data.AlertGroup == "EAD"){
         if(hireType == "C2C" || hireType == "1099")
          {
            url = `/employee`
          }
          else
          {
            url = `/employee/ead`
          }
      }
      else if(data.AlertGroup == "Projects"){
        url = `/employee/projects`
      }
      else if(data.AlertGroup == "PersonnelFile"){
        url = `/employee/`
      }
      else if(data.AlertGroup == "TimeSheets"){
        if(data.AlertClassification == "TimesheetPending"){
          if(data.EmployeeId == this.loggedInUserObj.empId){
            var str = data.Description;
            var sId = data.SourceId;
            var startDate = str.substring(31, 41);
            var endDate = str.substring(45, 55);
            var projectId = sId.replace(data.EmployeeId,"").replace(moment(startDate).format('YYYYMMDD')+moment(endDate).format('YYYYMMDD'),"")
            url = `/employee-addtimesheets?startDate=${startDate}&endDate=${endDate}&project=${projectId}`
          }
        }else{
          if(data.EmployeeId == this.loggedInUserObj.empId){
            url = `/my-timesheets`
          }else{

            localStorage.removeItem("SearchFilterPathLocation")
            localStorage.removeItem("SearchPathLocation")
            localStorage.removeItem("PathLocation")
            localStorage.removeItem("SearchPathLocation")
            localStorage.removeItem("searchText")
            localStorage.removeItem("IsSearchText")

            var calenderDate = data.FromDate != null ? moment(calenderDate).format("YYYY-MM-DD"):'';           

            url = `/employer-timesheets?calenderDate=${calenderDate}&searchText=${data.EmployeeEmail != null ? data.EmployeeEmail : ''}`
          }
        }
      }
      else if(data.AlertGroup == "Others")
      {  
       // this.getPassCode(data.EmployeeId, data.RecepientEmail);                
      }
      
       if(url != "") {
        window.open(url, "_blank")
      }
       
    },
    getTasks(){
      this.isLoading = true
      let searchAndFilter = {
        EmployeeId : this.EmployeeId,
        Filter: '',
        SearchIntent: 0
      }
      ajax.put(`/Task/GetTasks?pageNo=${this.pageNo}&pageSize=${this.pageSize}`, searchAndFilter , (res) => {
        var tasksLength = res.data.TasksMetaData.length;
        this.tasksTotalCount = res.data.Count;
        if(tasksLength > 0) {
          this.TaskList.push.apply(this.TaskList, res.data.TasksMetaData);
          if(tasksLength < this.pageSize)
            this.isLoadMoreTasks = false;
        }        
        else {
          this.isLoadMoreTasks = false;
        }
        this.isLoading = false
      })
    },
    loadMore() {
      if(this.IsTasks){
        this.getTasks()
        this.pageNo++
      }else{
        this.getAlerts()
        this.pageNo++
      }
    },
    readMethod(k) {
      let _this = this;
      ajax.put(`/Compliance/AlertMarkedasReadOrUnread?alertId=${k}`, {}, ( res ) => {
        let index = this.alerts.findIndex(a => a.Id == k)
        if(index != -1) {
          Vue.set(this.alerts[index], "IsRead", !this.alerts[index].IsRead )
        }
      });
    },
    deleteDisable(item){
      if(this.IsTasks){
        if(item.TaskCreatedBy.Email == this.loggedInUserObj.email){
          return false
        }
        else return true
      }
    },
    confirmDeletetask(item) {
      if(!this.deleteDisable(item)){
        this.$alert2("Are you sure you want to delete ?", "Alert", {
          type: "confirm",
          yesButtonText: "Yes",
          noButtonText: "No",
          callback: (action) => {
            if(action === true) {
              this.deleteTask(item.TaskId);
              //remove task local
              this.TaskList = this.TaskList.filter(function( obj ) {
                return obj.TaskId !== item.TaskId;
              });
              this.tasksTotalCount--
              this.$message({
                type: 'success',
                message: "Task Deleted Successfully"
              });
            }
          }
        });
      }
    },
    deleteTask(id) {
    var empId =  this.$route.query.EmployeeId
      var obj = {}
      obj.EmployeeId = empId ? empId : this.loggedInUserObj.empId
      obj.IsDeleteAll = false
      ajax.put(`/Task/${id}/Delete`, obj , (response) => {
        if(response.data.State == true){

        }
      })
    },
    onClickCard(item){
      var empId =  this.EmployeeId
      this.$router.push({name: 'employee-tasks-details', params: { id: item.TaskId}, query: {id:item.TaskId, EmployeeId:empId,from: this.$route.name }})
    },
    taskAdded(v){
      if(!v.IsAdded)
      {
        for(var i=0 ; i < this.TaskList.length ; i++ )
        {
          if(this.TaskList[i].TaskId == v.TaskId)
          {
            this.TaskList[i].CreatedBy = v.CreatedBy
            this.TaskList[i].CreatedDate = v.CreatedDate
            this.TaskList[i].Title = v.Title
            this.TaskList[i].Description = v.Description
          }
        }
      }
      else{
        var obj = {
          TaskId :v.TaskId,
          CreatedBy:v.CreatedBy,
          CreatedDate:v.CreatedDate,
          Title:v.Title,
          Description:v.Description,
          Status:"None"
        }
        this.tasksTotalCount++
        this.TaskList.unshift(obj)
      }
       this.TaskList.sort(function(a, b) {
          var dateA = new Date(a.CreatedDate), dateB = new Date(b.CreatedDate);
          return dateB - dateA;
      });
    },
    editTask(obj){
      if(!this.deleteDisable(obj)){
        this.isEdit = true
        this.previousData = obj
        this.openAddTaskPopup = true
      }
    },
    viewAll(){
      this.$router.push({name: 'view-all-alerts'})
    }
  }
}
</script>
<style lang="scss" scoped>
  .alert-container {
    height: 705px;
  }
  .alert-header {
    background: #fff;
    padding: 12px 15px;
    border: 1px solid #EDEEF0;
    h4 {
      display: inline-block;
      padding-right: 10px;
      font-weight: 600;
    }
    .span-color {
      background: #FED4DE;
      color: #DD3D64;
      border-radius: 10px;
      padding: 2px 11px;
      font-weight: 600;
    }
  }
  .alert-body {
    height: calc(100% - 55px);
    overflow: auto;
    background: #fff;
    border: 1px solid #EDEEF0;
    border-top: 0px;
  }
  .alert-content{
    cursor: pointer;
    padding: 15px 0px;
    border-bottom: 1px solid #EDEEF0;
    background: #fff;
  }
  .alert-content-unread {
    background: #fafafa;
  }
  .alert-time {
    padding: 5px 0px;
      p{
      display: inline-block;
        i{
          font-size: 13px;
          color: #777;
          padding-right: 5px;
      }
    }
  }
  .alert-header{
   .box-section-heading {
      color: #19223d;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: 0.5px;
      margin-right: 4px;
      cursor: pointer;
    }
  }
  .activeTab {
    border-bottom: 3px solid #4A90E2;
    .box-section-heading{
      color: #4A90E2;
    }
  }
  .Task-header {
    background: #fff;
    line-height: 52px;
    border-bottom: 1px solid #EDEEF0;
    h4 {
      display: inline-block;
      padding-right: 10px;
      font-weight: 550;
      font-size: 12px;
    }
  }
  .addTask{
    letter-spacing: 0.5px;
    margin-right: 4px;
    cursor: pointer;
    color:#91959e;
  }
  .addTask:hover {
    color: #337ab7;
  }
  .load-more-link {
    position: relative;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 5%;
    display: block;
    text-align: center;
  }

  .task-title{
    font-size: 13px;
    font-weight: 600;
    text-transform: capitalize;
  }
  .status{
    color:#F5A623;
    margin-left: 0px;
    border: 1px solid #F5A623 !important;
    background: #FEF6E9 !important;
    padding: 1px 12px;
    display: inline-block;
    border-radius: 30px;
    float: right;
    font-size: 12px;
    font-weight: 600;
  }
  .status1{
    color:#34BB93;
    margin-left: 0px;
    border: 1px solid #34BB93 !important;
    background: #E8F4F1 !important;
    padding: 1px 12px;
    display: inline-block;
    border-radius: 30px;
    float: right;
    font-size: 12px;
    font-weight: 600;
  }
  .alert-content:hover  .task-actions
  {
    display: block;
  }
  .task-actions{
    display: none;
  }
  #deleteButton{
    float:right;
  }
  #editButton{
    margin-right: 6px;
  }
  #deleteButton:hover,#editButton:hover{
    border-radius: 3px;
    background-color: #E8E8E9;
    // padding: 2px 4px 1px 4px;
  }
  .deleteTask{
    cursor: not-allowed !important;
    color: #00000057 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/ESSDashboard/Alerts.vue